import { render, staticRenderFns } from "./ConcurrencyWarningModal.vue?vue&type=template&id=79c871ba"
import script from "./ConcurrencyWarningModal.vue?vue&type=script&lang=ts"
export * from "./ConcurrencyWarningModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports